import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {NotificationsService} from 'angular2-notifications';
import {t} from '../shared/shared.module';
import {AuthorizationService} from '../authorization/authorization.service';
import {environment} from '../../environments/environment';

export class ErrorForbiddenInterceptor implements HttpInterceptor {
  constructor(
    protected notificationsService: NotificationsService,
    protected authorizationService: AuthorizationService,
  ) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!(error.error instanceof ErrorEvent)) {
          if (error.status === 403) {
            const errorText = req.method + ' ' + req.url.replace(environment.apiBasepoint, '.../') + '<br>' +
            'Role: ' + this.authorizationService.getIdentity().role;
            this.notificationsService.error(t('Access denied'), errorText, {timeOut: 0});
          }
        }
        return throwError(error);
      })
    );
  }
}
